var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-hot',{attrs:{"styles":("pad-h-1.4 pad-v-.4 round-sm mrg-r-.4 color-" + (_vm.tag_colors.normal.text) + " bg-color-" + (_vm.tag_colors.normal.bg)),"states":{
           act: {
               style: ("bg-color-" + (_vm.tag_colors.act.bg) + " color-" + (_vm.tag_colors.act.text)),
               state: _vm.selected
           }
       },"hover":("bg-color-" + (_vm.tag_colors.hover.bg) + " color-" + (_vm.tag_colors.hover.text))},on:{"on_click":_vm.$_click}},[_c('b-text',{attrs:{"styles":"scale-.9","states":{
                act: {
                    style: 'scale-1',
                    state: _vm.selected
                }
            }}},[_vm._v("\n        "+_vm._s(_vm.tag_text)+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba73d74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/tag/tag-widget.vue
// module id = null
// module chunks = 